import { useEffect, useState } from 'react';
import { db, collection, getDocs } from '../firebase';

export const usePurchaseHistory = (userId) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const historyRef = collection(db, 'users', userId, 'purchaseHistory');
        const snapshot = await getDocs(historyRef);

        if (snapshot.empty) {
          setHistory([]);
        } else {
          const data = snapshot.docs.map(docSnap => {
            const entry = docSnap.data();
            return {
              id: docSnap.id,
              ...entry,
              timestamp: entry.timestamp?.toDate?.() || new Date(entry.timestamp)
            };
          });

          data.sort((a, b) => b.timestamp - a.timestamp);
          setHistory(data);
        }
      } catch (err) {
        console.error('Error fetching history:', err);
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchHistory();
  }, [userId]);

  return { history, loading };
};
